import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TokenService } from '../services/token.service';

const parentOrigin = (() => {
  try {
    return document.referrer
      ? new URL(document.referrer).origin
      : globalThis.location.origin;
  } catch {
    return globalThis.location.origin;
  }
})();

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const tokenService = inject(TokenService);
  const jwtToken = tokenService.jwtToken();
  const clientId = tokenService.clientId();
  const providerId = tokenService.providerId();

  if (!request.url.startsWith(environment.apiUrl) || !jwtToken) {
    return next(request);
  }
  let headers = request.headers.set('Authorization', `Bearer ${jwtToken}`);

  if (clientId) {
    headers = headers.set('ADR-CLIENT-ID', clientId);
  } else if (providerId) {
    headers = headers.set('ADR-PROVIDER-ID', providerId);
  }

  return next(request.clone({ headers })).pipe(
    tap({
      error: (error: unknown) => {
        if (
          error instanceof HttpErrorResponse &&
          (error.status === 400 || error.status === 401 || error.status === 403)
        ) {
          const body = error.error;
          const message = body?.message ?? '';
          if (isDevMode()) {
            console.warn(`[Auth] ${error.status}: ${message}`);
          }
          if (error.status === 401 || error.status === 403) {
            globalThis.parent.postMessage({ type: 'logout' }, parentOrigin);
          }
        }
      },
    }),
  );
};
